import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { Helper, DateHelper } from '@hems/util/src';
import { getTime } from '@hems/util/src/helper/dateHelper';
export function getParam(date, type, tabname, baseDeviceInfo) {
    switch (tabname) {
        case 'hourly':
            return {
                from: DateHelper.formatDateByInterval(date.hourly, tabname),
                to: DateHelper.formatDateByInterval(DateHelper.getHourlyEndValue(date.hourly), tabname),
                type,
                ...baseDeviceInfo,
            };
        case 'daily':
            return {
                from: DateHelper.formatDateByInterval(date.daily.start, tabname),
                to: DateHelper.formatDateByInterval(date.daily.end, tabname),
                type,
                ...baseDeviceInfo,
            };
        case 'monthly':
            return {
                from: DateHelper.formatDateByInterval(date.monthly.start, tabname),
                to: DateHelper.formatDateByInterval(date.monthly.end, tabname),
                type,
                ...baseDeviceInfo,
            };
        case 'yearly':
            return {
                from: DateHelper.formatDateByInterval(date.yearly.start, tabname),
                to: DateHelper.formatDateByInterval(date.yearly.end, tabname),
                type,
                ...baseDeviceInfo,
            };
    }
}
export function getXAxisTitleText(tabname, t) {
    switch (tabname) {
        case 'hourly':
            return `(${t('common.hour')})`;
        case 'daily':
            return `(${t('common.day')})`;
        case 'monthly':
            return `(${t('common.month')})`;
        default:
            return '';
    }
}
export function getParams(date, type, baseDeviceInfo) {
    return {
        from: date.start.getTime(),
        to: date.end.getTime(),
        type,
        ...baseDeviceInfo,
    };
}
export function getCategorie(tabname, time) {
    switch (tabname) {
        case 'hourly':
            return moment(time).hours();
        case 'monthly':
            return moment(time).month();
        case 'daily':
            return moment(time).date();
        default:
            return null;
    }
}
export function getCategories(tabname, time) {
    switch (tabname) {
        case 'hourly':
            return moment(time).hours().toString();
        case 'monthly':
            return moment(time).month().toString();
        case 'daily':
            return moment(time).date().toString();
        default:
            return '';
    }
}
export function getOverviewDateFormat(value) {
    return moment(value).format('YYYY/MM');
}
export function getChartDateFormat(tabname, value, locale) {
    switch (tabname) {
        case 'hourly':
            return DateHelper.getDateFormatter(locale, { hour: 'numeric' }).format(value).toString();
        case 'daily':
            return DateHelper.getDateFormatter(locale, { day: 'numeric', month: 'short' }).format(value).toString();
        case 'monthly':
            return DateHelper.getDateFormatter(locale, { month: 'numeric' }).format(value).toString();
        default:
            return '';
    }
}
export function getShortMonth(month) {
    const date = new Date();
    date.setMonth(month);
    return date.toLocaleString('en-us', { month: 'short' });
}
export function getChartDateFormatForTooltip(tabname, value) {
    switch (tabname) {
        case 'hourly':
            return DateHelper.getLocalDate(value, { isTime: true, isSecond: false });
        case 'daily':
            return DateHelper.getLocalDate(value, { isTime: false, isSecond: false });
        case 'monthly':
            return DateHelper.getLocalDate(value, { isMonthly: true });
        default:
            return '';
    }
}
export function divideArray(data, count) {
    try {
        while (data.length < 10) {
            data.push(null);
        }
        return new Array(Math.ceil(data.length / count)).fill([]).map(() => data.splice(0, count));
    }
    catch (e) {
        console.error(e);
        return [[], [], [], [], []];
    }
}
export function getOverviewData(result) {
    const data = {
        generation: [],
        consumption: [],
        feedin: [],
        demand: [],
        charge: [],
        discharge: [],
    };
    if (result && result.colec_time) {
        result.colec_time.forEach((item, index) => {
            data.generation.push({
                y: Number(Helper.toFixed(result.gen_data[index] || 0, 2)),
                x: DateHelper.getTime(item, 'monthly'),
            });
            data.consumption.push({
                y: Number(Helper.toFixed(result.con_data[index] || 0, 2)),
                x: DateHelper.getTime(item, 'monthly'),
            });
            data.feedin.push({
                y: Number(Helper.toFixed(result.feedin_data[index] || 0, 2)),
                x: DateHelper.getTime(item, 'monthly'),
            });
            data.demand.push({
                y: Number(Helper.toFixed(result.demand_data[index] || 0, 2)),
                x: DateHelper.getTime(item, 'monthly'),
            });
            data.charge.push({
                y: Number(Helper.toFixed(result.btc_data[index] || 0, 2)),
                x: DateHelper.getTime(item, 'monthly'),
            });
            data.discharge.push({
                y: Number(Helper.toFixed(result.btd_data[index] || 0, 2)),
                x: DateHelper.getTime(item, 'monthly'),
            });
        });
    }
    return data;
}
export function getDateString(value, locale) {
    return DateHelper.getDateFormatter(locale, { year: 'numeric', month: '2-digit' }).format(value).toString();
}
export function formattedValue(value, locale, decimal = 2) {
    return Helper.getNumberFormatter(locale, { minimumFractionDigits: decimal, maximumFractionDigits: decimal })
        .format(value)
        .toString();
}
export function formattedValueForSoc(item, locale) {
    if (item != null && item.y != 0)
        return Helper.getNumberFormatter(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
            .format(item.y)
            .toString();
    return '0';
}
export function getTooltipTextForSoc(tabname, object, t) {
    if (tabname == 'hourly') {
        return `
  <span style="color:#9b5ba4;padding:0">● </span>
  <span><b>${t('device.soc')}</b> : </span><span style="padding:0"><br><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  - ${object.points != null ? object.points[2].y : 0}%</span></td></tr><tr><td><br><br>`;
    }
    return '';
}
export function getTickPositions(tabname, value) {
    if (tabname == 'monthly')
        return value;
    return undefined;
}
export function socOfYaxisIsVisible(tabname) {
    switch (tabname) {
        case 'hourly':
            return true;
        default:
            return false;
    }
}
export function getEnergyBalance(energyBalance, locale, t) {
    try {
        if (!energyBalance.length) {
            return [[], [], [], [], []];
        }
        return energyBalance.map((array) => array
            .filter((item) => item != null)
            .map((item) => ({
            type: t(item.type) === '' ? item.type : t(item.type),
            value: formattedValue(Number(item.value), locale),
            unit: item.unit,
            detailMessageInfo: item.detailMessageInfo ?? undefined,
        })));
    }
    catch (e) {
        console.error(e);
        return [[], [], [], []];
    }
}
export function getTooltipOfGeneration(tabname, object, locale, t, co2) {
    const container = document.createElement('span');
    container.setAttribute('style', `
          position: absolute;
          font-family: 'Lucida Grande', 'Lucida Sans Unicode', Arial, Helvetica, sans-serif;
          font-size: 12px;
          white-space: nowrap;
          margin-left: 0px;
          margin-top: 0px;
          left: 8px;
          top: 8px;
          color: rgb(51, 51, 51);
          `);
    const date = document.createElement('span');
    date.innerHTML = `${getChartDateFormatForTooltip(tabname, object.x)} <br/>`;
    const table = document.createElement('table');
    const tbody = table.createTBody();
    object.points?.forEach((item) => {
        const tr = document.createElement('tr');
        const td = document.createElement('td');
        const specialCharacters = document.createElement('span');
        const energyName = document.createElement('span');
        const energyValue = document.createElement('span');
        specialCharacters.setAttribute('style', `color: ${item.color}; padding: 0`);
        specialCharacters.innerHTML = '● ';
        energyName.innerHTML = `<b>${item.series.name}</b> : <br/>`;
        energyValue.setAttribute('style', 'padding : 0');
        energyValue.innerHTML = `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - ${getEnergyValue(item, locale, t)} <br/>`;
        td.append(specialCharacters);
        td.append(energyName);
        td.append(energyValue);
        tr.append(td);
        tbody.append(tr);
    });
    // CO2
    const tr = document.createElement('tr');
    const td = document.createElement('td');
    const energyValue = document.createElement('span');
    energyValue.setAttribute('style', 'padding : 0');
    energyValue.innerHTML = `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -  ${t('device.co_reduction')} : 
  ${co2 != null ? formattedValue(co2.y ?? 0, locale) : 0}kg <br/>`;
    td.append(energyValue);
    tr.append(td);
    tbody.append(tr);
    table.append(date);
    table.append(tbody);
    container.append(table);
    return `${container.innerHTML}`;
}
export function getValueOfToolTip(tabname, object, locale, t) {
    const container = document.createElement('span');
    container.setAttribute('style', `
          position: absolute;
          font-family: 'Lucida Grande', 'Lucida Sans Unicode', Arial, Helvetica, sans-serif;
          font-size: 12px;
          white-space: nowrap;
          margin-left: 0px;
          margin-top: 0px;
          left: 8px;
          top: 8px;
          color: rgb(51, 51, 51);
          `);
    const date = document.createElement('span');
    date.innerHTML = `${getChartDateFormatForTooltip(tabname, object.x)} <br/>`;
    const table = document.createElement('table');
    const tbody = table.createTBody();
    object.points?.forEach((item) => {
        const tr = document.createElement('tr');
        const td = document.createElement('td');
        const specialCharacters = document.createElement('span');
        const energyName = document.createElement('span');
        const energyValue = document.createElement('span');
        specialCharacters.setAttribute('style', `color: ${item.color}; padding: 0`);
        specialCharacters.innerHTML = '● ';
        energyName.innerHTML = `<b>${item.series.name}</b> : <br/>`;
        energyValue.setAttribute('style', 'padding : 0');
        energyValue.innerHTML = `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - ${getEnergyValue(item, locale, t)} <br/>`;
        td.append(specialCharacters);
        td.append(energyName);
        td.append(energyValue);
        tr.append(td);
        tbody.append(tr);
    });
    table.append(date);
    table.append(tbody);
    container.append(table);
    return `${container.innerHTML}`;
}
function getEnergyValue(item, locale, t) {
    if (item.series.name == t('device.soc')) {
        return `${formattedValueForSoc(item, locale)}%`;
    }
    return `${t('common.energy')} : ${item != null ? formattedValue(item.y, locale) : 0}kWh`;
}
export function getDateInitialValue(value, start) {
    return {
        hourly: getHourlyStartValuyBy(getTime(value, 'hourly')),
        monthly: {
            start: getMonthlyStartValueBy(getTime(value, 'monthly')),
            end: getMonthlyEndValueBy(getTime(value, 'monthly')),
        },
        daily: {
            start: getDailyStartValueBy(getTime(value, 'daily')),
            end: getDailyEndValueBy(getTime(value, 'daily')),
        },
        yearly: {
            start: start
                ? getYearlyStartValueBy(getTime(start.getFullYear(), 'yearly'))
                : getYearlyStartValueBy(getTime(value, 'yearly')),
            end: getYearlyEndValueBy(getTime(value, 'yearly')),
        },
    };
}
export function getNowByClient(timeZone) {
    return momentTimezone().tz(timeZone).startOf('day').format('YYYYMMDDHH');
}
export function getHourlyStartValuyBy(value) {
    return moment(value).startOf('day').toDate();
}
export function getMonthlyStartValueBy(value) {
    const now = moment(value);
    return now
        .month(now.month() - 1)
        .startOf('month')
        .toDate();
}
export function getMonthlyEndValueBy(value) {
    return moment(value).endOf('month').toDate();
}
export function getDailyStartValueBy(value) {
    const now = moment(value);
    return now
        .date(now.date() - 7)
        .startOf('day')
        .toDate();
}
export function getDailyEndValueBy(value) {
    return moment(value).endOf('day').toDate();
}
export function getYearlyStartValueBy(value) {
    return moment(value).startOf('year').toDate();
}
export function getYearlyEndValueBy(value) {
    return moment(value).endOf('year').toDate();
}
